<template>
  <div class="landing-wrapper">
    <v-container class="py-8 py-md-12" fluid>
      <v-row justify="center">
        <v-col cols="12" lg="10">
          <v-alert v-if="error" type="error" class="mb-4" closable @click:close="error = ''">
            {{ error }}
          </v-alert>

          <div v-if="loading" class="d-flex justify-center py-8">
            <v-progress-circular indeterminate color="primary" size="48" />
          </div>

          <template v-else>
          <div class="cia-toolbar">
            <button type="button" class="cia-new-btn" @click="goToNew">
              CREAR PRODUCTORA
            </button>
          </div>

          <div class="cia-panel">
            <div class="cia-panel-header">
              <v-icon size="22" color="#ffffff">mdi-movie-open-outline</v-icon>
              <span>PRODUCTORAS</span>
            </div>

            <div class="cia-panel-body">
              <div class="cia-table-scroll">
                <table class="cia-table">
                  <thead>
                    <tr>
                      <th>NOMBRE</th>
                      <th>ESTADO</th>
                      <th class="cia-col-actions">ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in productoras" :key="p.id">
                      <td class="cia-cell-name">{{ p.name }}</td>
                      <td>
                        <span
                          class="cia-status"
                          :class="p.active ? 'cia-status-on' : 'cia-status-off'"
                        >
                          {{ p.active ? 'ACTIVA' : 'INACTIVA' }}
                        </span>
                      </td>
                      <td>
                        <button
                          type="button"
                          class="cia-edit-btn"
                          @click="goToEdit(p)"
                        >
                          <v-icon size="18">mdi-pencil-outline</v-icon>
                          EDITAR
                        </button>
                      </td>
                    </tr>
                    <tr v-if="productoras.length === 0">
                      <td colspan="3" class="cia-empty">
                        No hay productoras registradas.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </template>
        </v-col>
      </v-row>
    </v-container>

    <teatro-footer />
  </div>
</template>

<script>
import { fetchProductoras } from "@/services/teatroApi";

export default {
  name: "ProductoraList",
  data() {
    return {
      productoras: [],
      loading: true,
      error: "",
    };
  },
  async created() {
    await this.loadAuth();
    await this.load();
  },
  methods: {
    async loadAuth() {
      try {
        await this.$store.dispatch("fetchIsAuthenticated");
      } catch (e) {
        console.error(e);
      }
    },
    async load() {
      this.loading = true;
      this.error = "";
      try {
        this.productoras = (await fetchProductoras()) || [];
      } catch (e) {
        this.error = "No se pudieron cargar las productoras.";
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    goToEdit(p) {
      window.location.href = `/productoras/${p.id}/editar/`;
    },
    goToNew() {
      window.location.href = "/productoras/nueva/";
    },
  },
};
</script>

<style scoped>
.cia-toolbar {
  max-width: 1080px;
  margin: 0 auto 18px;
  display: flex;
  justify-content: flex-end;
}

.cia-new-btn {
  background: linear-gradient(90deg, #c8102e 0%, #a50d25 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 28px;
  font-family: var(--font-family-heading);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(200, 16, 46, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cia-new-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(200, 16, 46, 0.45);
}

.cia-panel {
  max-width: 1080px;
  margin: 0 auto;
  background: rgba(8, 5, 5, 0.66);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 26px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
}

.cia-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 66px;
  padding: 0 32px;
  background: linear-gradient(90deg, #c8102e 0%, #a50d25 100%);
  color: #fff;
  font-family: var(--font-family-heading);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.4px;
}

.cia-panel-body {
  padding: 28px 34px 30px;
}

.cia-table-scroll {
  overflow-x: auto;
}

.cia-table {
  width: 100%;
  border-collapse: collapse;
  color: var(--color-theater-text);
  font-family: var(--font-family-heading);
}

.cia-table th {
  text-align: left;
  padding: 8px 16px 18px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.55);
  white-space: nowrap;
}

.cia-table td {
  padding: 15px 16px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  vertical-align: middle;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.cia-table tbody tr:first-child td {
  border-top: none;
}

.cia-cell-name {
  text-transform: uppercase;
}

.cia-status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.8px;
}

.cia-status-on {
  background: rgba(46, 160, 87, 0.18);
  color: #66d38a;
}

.cia-status-off {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
}

.cia-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: var(--color-theater-text);
  cursor: pointer;
  font-family: var(--font-family-heading);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.cia-edit-btn:hover {
  opacity: 0.72;
  transform: translateY(-1px);
}

.cia-empty {
  text-align: center;
  padding: 30px 16px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}
</style>
